import { Navigate, createBrowserRouter } from "react-router-dom";

import { BareLayout } from "@/components/bare-layout";
import { RootLayout } from "@/components/root-layout";
import { BuildPage } from "@/pages/build-page";
import { CreatePage } from "@/pages/create-page";
import { DesignPage } from "@/pages/design-page";
import { IntegratePage } from "@/pages/integrate-page";
import { LoginPage } from "@/pages/login-page";
import { PreviewPage } from "@/pages/preview-page";
import { PublicPreviewPage } from "@/pages/public-preview-page";
import { SkedAuthPage } from "@/pages/sked-auth-page";
import {
  AuthenticatedRoute,
  ProtectedRoute,
  PublicRoute,
} from "@/router/route-guards";

export const router = createBrowserRouter([
  // Public routes (no admin chrome, no auth bootstrap)
  {
    element: <BareLayout />,
    children: [{ path: "/preview/:username", element: <PublicPreviewPage /> }],
  },

  // Admin routes (header + Link session bootstrap)
  {
    element: <RootLayout />,
    children: [
      // unguarded
      { path: "/auth/redirect/:token", element: <SkedAuthPage /> },

      // public-only (redirect to /build when already authenticated)
      {
        element: <PublicRoute />,
        children: [{ path: "/login", element: <LoginPage /> }],
      },

      // authenticated (login required, account not required)
      {
        element: <AuthenticatedRoute />,
        children: [{ path: "/create", element: <CreatePage /> }],
      },

      // protected (login + at least one account required)
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/build", element: <BuildPage /> },
          { path: "/design", element: <DesignPage /> },
          { path: "/integrate", element: <IntegratePage /> },
          { path: "/preview", element: <PreviewPage /> },
        ],
      },

      // catch-all: bounce to /login (matches legacy behaviour)
      { path: "*", element: <Navigate to="/login" replace /> },
    ],
  },
]);
